// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  turbotwinOrgId: __t.string().name("turbotwin_org_id"),
  setBy: __t.identity().name("set_by"),
  setAt: __t.timestamp().name("set_at"),
  webclientBaseUrl: __t.option(__t.string()).name("webclient_base_url"),
  githubAppInstallUrl: __t.option(__t.string()).name("github_app_install_url"),
});
